// extracted by mini-css-extract-plugin
export var blue = "_3g-g";
export var brand = "_3g-c";
export var darkGrey = "_3g-f";
export var disabled = "_3g-6";
export var disabledSubtle = "_3g-7";
export var error = "_3g-8";
export var green = "_3g-h";
export var grey = "_3g-e";
export var icon = "_3g-0";
export var inherit = "_3g-b";
export var lightGrey = "_3g-d";
export var orange = "_3g-j";
export var pink = "_3g-l";
export var primary = "_3g-1";
export var purple = "_3g-m";
export var quaternary = "_3g-4";
export var quinary = "_3g-5";
export var red = "_3g-k";
export var secondary = "_3g-2";
export var success = "_3g-a";
export var tertiary = "_3g-3";
export var warning = "_3g-9";
export var white = "_3g-n";
export var yellow = "_3g-i";